import * as React from 'react';

import { useTheme } from '../../../../../../theme';
import { useExchangeRouteControls } from '../../lib';
import { ExchangeRefundControls } from '@entities/order';

const ExchangeControlsWrapper: React.FC = ({ children }) => {
	const { ExchangeControlsWrapper: theme } = useTheme('Features').Exchange;

	const { isShowControls, isEnableContinue, onBack, onContinue } = useExchangeRouteControls();

	return (
		<div className={theme.wrapper}>
			<div className={theme.content}>{children}</div>

			{isShowControls && (
				<div className={theme.controls}>
					<ExchangeRefundControls
						onBack={onBack}
						continueButtonProps={
							onContinue
								? {
										onClick: onContinue,
										disabled: !isEnableContinue
								  }
								: undefined
						}
					/>
				</div>
			)}
		</div>
	);
};

export default ExchangeControlsWrapper;
